import { fetchKioskData } from '../context/kioskActions';
import { useContext, useEffect } from 'react';
import { kioskContext } from '../context/kioskContext';
import useInterval from './useInterval';

const MINUTE = 1000 * 60;

const useUpdatingKioskState = () => {
  const { kioskState, dispatch } = useContext(kioskContext);

  useEffect( () => {
    if (!kioskState.isFetched && !kioskState.isLoading) {
      fetchKioskData(kioskState, dispatch);
    }
  }, [ kioskState.isFetched ]);

  useInterval( () => {
    if (!kioskState.isLoading) {
      fetchKioskData(kioskState, dispatch);
    }
  }, MINUTE);

  return [ kioskState, dispatch ];
};

export default useUpdatingKioskState;
